/* import __COLOCATED_TEMPLATE__ from './cache-control.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

export default class CacheControlComponent extends Component 
{
	@service ajax;
	
	@action
	eventDurationChanged(event)
	{
		var duration = event.target.value;
		var that = this;
		this.ajax.put("/cacheControl/results",{ data:{duration: duration}}).catch(function(error)
		{
			that.get('ajax').request("/cacheControl").then(function(currentValues)
			{
				that.cacheSettings = currentValues;
			});
		});
	}
	
	@action
	classGroupDurationChanged(event)
	{
		var duration = event.target.value;
		var that = this;
		this.ajax.put("/cacheControl/results/classGroup",{ data:{duration: duration}}).catch(function(error)
		{
			that.get('ajax').request("/cacheControl").then(function(currentValues)
			{
				that.cacheSettings = currentValues;
			});
		});
	}
}

